// extracted by mini-css-extract-plugin
module.exports = {"component":"AlertNoData_component__1CFxm","link":"AlertNoData_link__1_lSY"};